import FacesCard from "./FacesCard";

export default FacesCard;